
import * as _asset0 from "inline-asset:assets/galleries/featured/street_bd09cadfa7__20.jpg";
import * as _asset1 from "asset:assets/galleries/featured/street_bd09cadfa7__400.jpg";
import * as _asset2 from "asset:assets/galleries/featured/street_bd09cadfa7__800.jpg";
import * as _asset3 from "asset:assets/galleries/featured/street_bd09cadfa7__1600.jpg";


export default {
  id: "street",
  aspect: 1.568816658202133,
  alt: undefined,
  sources: [{
              url: _asset0.url,
              width: 20,
            },{
              url: _asset1.url,
              width: 400,
            },{
              url: _asset2.url,
              width: 800,
            },{
              url: _asset3.url,
              width: 1600,
            }],
};
        